const processFormDataWithCustomFields = (formData, storeCustomFields) => {
  // If no custom fields to process, return the original formData
  console.log(formData, "aaaaaaaaaaaaa", storeCustomFields, !formData.customFieldData);
  if ((!storeCustomFields || storeCustomFields.length === 0) && !formData.customFieldData) {
    return formData;
  }

  const customFieldData = {};
  let keyArr = [];
  // Iterate over each key in formData
  if (formData.customFieldData) {
    keyArr = Object.keys(formData.customFieldData);
  }
  for (const key in formData) {
    if (keyArr.includes(key)) {
      customFieldData[key] = formData[key] ?? "";
      // Remove the field from formData
      delete formData[key];
    }
    if (storeCustomFields.includes(key)) {
      // Move the matched field to customFieldData
      customFieldData[key] = formData[key] ?? "";
      // Remove the field from formData
      delete formData[key];
    }
  }

  // Only add customFieldData if it's not empty
  if (Object.keys(customFieldData).length > 0) {
    formData.customFieldData = customFieldData;
  }
  console.log(formData, "aaaa");
  return formData;
};

export default processFormDataWithCustomFields;
